// Small emerald pill worn by VIP users on the Dashboard, Settings, and
// anywhere else we surface the current user's identity. Renders nothing
// if the user isn't VIP so the same JSX slot can be dropped in unguarded.

import { Crown } from "lucide-react";

export const VipBadge = ({ user, size = "sm" }) => {
  if (!user?.is_vip) return null;
  const cls = size === "lg"
    ? "px-3 py-1 text-xs"
    : "px-2 py-0.5 text-[10px]";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold uppercase tracking-wider bg-gradient-to-r from-[#F6C071] to-[#E29B4C] text-white ${cls}`}
      data-testid="vip-badge"
      title="VIP All Access via CALM100 early-access program"
    >
      <Crown className="w-3 h-3" />
      VIP
    </span>
  );
};

export default VipBadge;
